import Typography from '@/common/components/base/typography/Typography.tsx';
import RightArrow from '@/common/assets/icons/arrowRightIcon.svg?react';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import useModal from '@/common/hooks/useModal.ts';
import { Center, Flex } from 'styled-system/jsx';
import { useQuery } from '@tanstack/react-query';
import { fileDetailQueryOption } from '@/modules/FileList/queries/fileDetail/fileDetailQueryOption.ts';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard.tsx';
import FileHeader from '@/common/components/DetailCard/headers/fileHeader/FileHeader.tsx';
import DetailCardBody from '@/common/components/DetailCard/DetailCardBody.tsx';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems.tsx';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import { css } from 'styled-system/css';
import InfoIcon from '@/common/assets/icons/infoCircleIcon.svg?react';
import LeftArrow from '@/common/assets/icons/leftArrow.svg?react';
import { token } from 'styled-system/tokens';
import RelatedFilesModal from '@/common/components/modals/relatedFiles/RelatedFilesModal.tsx';
import { FileDetailModalPropsType } from '@/modules/FileList/components/modals/fileDetailModals/FileDetailModal.type.ts';

export default ({ id }: FileDetailModalPropsType) => {
  const { open, openModal, closeModal } = useModal();
  return (
    <>
      <Flex onClick={openModal} alignItems="center">
        <Typography cursor="pointer" ml="3px" textStyle="b4" color="black-4">
          مشاهده جزئیات
        </Typography>
        <RightArrow width="10px" />
      </Flex>
      <MainModal closeModal={closeModal} open={open}>
        <FileDetailModal id={id} />
      </MainModal>
    </>
  );
};

const FileDetailModal = ({ id }: FileDetailModalPropsType) => {
  const { data, isPending } = useQuery(fileDetailQueryOption({ id }));
  const { openModal, open, closeModal } = useModal();
  if (isPending || !data) {
    return (
      <Center height="300px">
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }
  const { fileType, detailCardItems, relatedFilesNumber } = data;
  return (
    <>
      <TitleDescription>جزئیات پرونده</TitleDescription>
      {relatedFilesNumber ? (
        <Flex
          onClick={openModal}
          backgroundColor="white"
          height="48px"
          border="1px solid {colors.orange-1}"
          borderRadius="8px"
          alignItems="center"
          justifyContent="space-between"
          px="10px"
          mt="20px"
          cursor="pointer"
        >
          <Center>
            <InfoIcon
              width="16px"
              height="16px"
              stroke={token('colors.orange')}
            />
            <Typography mr="5px" textStyle="b2">
              {relatedFilesNumber} پرونده مرتبط با این پرونده وجود دارد
            </Typography>
          </Center>
          <Typography
            alignItems="center"
            display="flex"
            textStyle="b4"
            color="orange"
            gap="2px"
          >
            مشاهده
            <LeftArrow stroke={token('colors.orange')} />
          </Typography>
        </Flex>
      ) : null}
      <MainDetailCard className={css({ my: '20px' })}>
        <FileHeader fileType={fileType} />
        <DetailCardBody>
          <DetailCardItems
            items={detailCardItems}
            backgroundColor={
              fileType === 'body'
                ? 'orange-2'
                : fileType === 'initial'
                  ? 'blue-1'
                  : 'pink-1'
            }
          />
        </DetailCardBody>
      </MainDetailCard>
      <RelatedFilesModal closeModal={closeModal} open={open} id={id} />
    </>
  );
};
